import * as React from 'react'

export function RoutinesSunset(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M9.222 23C10 19.554 12.744 17 16 17s6 2.554 6.779 6H9.222zM16 15c4.637 0 8.454 3.836 8.947 8.89A1.011 1.011 0 0123.946 25H8.055a1.01 1.01 0 01-1.001-1.11C7.546 18.836 11.364 15 16 15zm15 5c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1h4zM5 20c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h4zm18.706-4.466a1 1 0 01-1.414-1.414l2.828-2.828a1 1 0 011.414 1.414l-2.828 2.828zm-15.586 0l-2.828-2.828a1 1 0 011.414-1.414l2.828 2.828a1.003 1.003 0 010 1.414 1.003 1.003 0 01-1.414 0zm10.173-6.236a.999.999 0 111.414 1.414l-2.995 2.995a.999.999 0 01-1.414 0l-2.995-2.995a.999.999 0 111.414-1.414l1.284 1.284L14.999 7a1 1 0 112 0l.002 3.59 1.292-1.292z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
